import { render, staticRenderFns } from "./ImageViewer.vue?vue&type=template&id=650a18b3&scoped=true"
import script from "./ImageViewer.vue?vue&type=script&lang=js"
export * from "./ImageViewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "650a18b3",
  null
  
)

export default component.exports